import { gql } from "@apollo/client"

export const GET_ENTERPRISES = gql`
  query Enterprises($staff_id: ID!, $enterprise_id: ID!) {
    enterprises: statsEnterprisesByUid(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
    ) {
      enterprise_id
      enterprise_name
      enterprise_status
      current_organizations
      current_staff_users
      current_participants
      current_programs
      current_locations
      enterprise_id_stamp
    }
  }
`

export const CHANGE_STATUS_ENTERPRISE = gql`
  mutation ChangeStatusEnterprise(
    $staff_id: String!
    $enterprise_id: String!
    $enterprise_status: String!
  ) {
    changeEnterpriseStatus(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
      enterprise_status: $enterprise_status
    ) {
      enterprise_id
    }
  }
`
